import React from "react";
import {FieldContext} from "@morningtrain/react-fields";
import {observable} from "mobx";
import { useForm } from '@morningtrain/react-resources'

function AddRepeaterItem() {

    const form = useForm()
    const field = React.useContext(FieldContext);

    const addItem = () => {
        if(field.appendNew === true) {
            field.value.push(observable.map());
        } else {
            field.value.unshift(observable.map());
        }
        if(form && typeof form.setAsChanged === 'function') {
            form.setAsChanged();
        }
    }

    if(field.displayOnly === true) {
        return null;
    }

    return (
        <button type={'button'} className={field.buttonClass} onClick={addItem}>{field.addLabel}</button>
    );
}

export default AddRepeaterItem;
